const NavbarLogoSmall = () => (
    <svg
        width='22'
        height='36'
        viewBox='0 0 22 36'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='navbar-logo-small'
    >
        <path
            d='M15.7173 35.697L21.2981 32.6692C21.4765 32.5727 21.6254 32.4297 21.7292 32.2555C21.8329 32.0813 21.8876 31.8822 21.8875 31.6795V0.895504C21.8877 0.775422 21.8558 0.657474 21.7951 0.553835C21.7344 0.450196 21.6472 0.364619 21.5425 0.305932C21.4377 0.247246 21.3192 0.217575 21.1991 0.219985C21.0791 0.222394 20.9618 0.256798 20.8595 0.319641L15.2584 3.74108C15.0939 3.8417 14.9581 3.98287 14.864 4.15107C14.7698 4.31927 14.7205 4.50884 14.7207 4.7016V35.1054C14.721 35.2222 14.7516 35.3369 14.8095 35.4383C14.8674 35.5398 14.9506 35.6244 15.051 35.684C15.1515 35.7437 15.2656 35.7762 15.3824 35.7785C15.4992 35.7807 15.6146 35.7527 15.7173 35.697Z'
            fill='url(#paint0_linear_3859_1202)'
        />
        <path
            d='M11.8048 27.4278V34.1762C11.8047 34.2552 11.7839 34.3327 11.7444 34.401C11.7049 34.4694 11.6481 34.5261 11.5797 34.5655C11.5113 34.6049 11.4337 34.6257 11.3548 34.6257C11.2759 34.6257 11.1983 34.6049 11.13 34.5654L7.28792 32.3272L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28832 23.2514 7.39245 23.6388 7.58986 23.9803C7.78727 24.3219 8.07103 24.6055 8.41265 24.8027L11.2537 26.4561C11.4223 26.556 11.5618 26.6982 11.6585 26.8687C11.7551 27.0391 11.8056 27.2319 11.8048 27.4278Z'
            fill='url(#paint1_linear_3859_1202)'
        />
        <path
            d='M11.13 34.5587L7.28792 32.3204L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28792 22.8569 6.84249 27.4008 11.13 34.5587Z'
            fill='url(#paint2_radial_3859_1202)'
        />
        <path
            d='M15.7173 35.697L21.2981 32.6692C21.4765 32.5727 21.6254 32.4297 21.7292 32.2555C21.8329 32.0813 21.8876 31.8822 21.8875 31.6795V0.895504C21.8877 0.775422 21.8558 0.657474 21.7951 0.553835C21.7344 0.450196 21.6472 0.364619 21.5425 0.305932C21.4377 0.247246 21.3192 0.217575 21.1991 0.219985C21.0791 0.222394 20.9618 0.256798 20.8595 0.319641L15.2584 3.74108C15.0939 3.8417 14.9581 3.98287 14.864 4.15107C14.7698 4.31927 14.7205 4.50884 14.7207 4.7016V35.1054C14.721 35.2222 14.7516 35.3369 14.8095 35.4383C14.8674 35.5398 14.9506 35.6244 15.051 35.684C15.1515 35.7437 15.2656 35.7762 15.3824 35.7785C15.4992 35.7807 15.6146 35.7527 15.7173 35.697Z'
            fill='url(#paint3_linear_3859_1202)'
        />
        <path
            d='M11.8048 27.4278V34.1762C11.8047 34.2552 11.7839 34.3327 11.7444 34.401C11.7049 34.4694 11.6481 34.5261 11.5797 34.5655C11.5113 34.6049 11.4337 34.6257 11.3548 34.6257C11.2759 34.6257 11.1983 34.6049 11.13 34.5654L7.28792 32.3272L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28832 23.2514 7.39245 23.6388 7.58986 23.9803C7.78727 24.3219 8.07103 24.6055 8.41265 24.8027L11.2537 26.4561C11.4223 26.556 11.5618 26.6982 11.6585 26.8687C11.7551 27.0391 11.8056 27.2319 11.8048 27.4278Z'
            fill='url(#paint4_linear_3859_1202)'
        />
        <path
            d='M11.13 34.5587L7.28792 32.3204L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28792 22.8569 6.84249 27.4008 11.13 34.5587Z'
            fill='url(#paint5_radial_3859_1202)'
        />
        <path
            opacity='0.3'
            d='M15.3952 35.8923C15.1864 35.8923 14.9862 35.8094 14.8385 35.6617C14.6909 35.5141 14.6079 35.3138 14.6079 35.105V4.7012C14.6085 4.4892 14.6631 4.28084 14.7666 4.09584C14.8701 3.91084 15.0192 3.75531 15.1995 3.64395L20.8007 0.222506C20.9245 0.148484 21.0659 0.108882 21.2101 0.107788C21.4191 0.107787 21.6196 0.190662 21.7677 0.338247C21.9157 0.485833 21.9991 0.686086 21.9997 0.895101V31.6791C21.9994 31.902 21.939 32.1207 21.825 32.3123C21.711 32.5038 21.5476 32.6612 21.3518 32.7678L15.7709 35.7956C15.6561 35.8595 15.5267 35.8928 15.3952 35.8923Z'
            fill='url(#paint6_linear_3859_1202)'
        />
        <path
            d='M15.7173 35.697L21.2981 32.6692C21.4765 32.5727 21.6254 32.4297 21.7292 32.2555C21.8329 32.0813 21.8876 31.8822 21.8875 31.6795V0.895504C21.8877 0.775422 21.8558 0.657474 21.7951 0.553835C21.7344 0.450196 21.6472 0.364619 21.5425 0.305932C21.4377 0.247246 21.3192 0.217575 21.1991 0.219985C21.0791 0.222394 20.9618 0.256798 20.8595 0.319641L15.2584 3.74108C15.0939 3.8417 14.9581 3.98287 14.864 4.15107C14.7698 4.31927 14.7205 4.50884 14.7207 4.7016V35.1054C14.721 35.2222 14.7516 35.3369 14.8095 35.4383C14.8674 35.5398 14.9506 35.6244 15.051 35.684C15.1515 35.7437 15.2656 35.7762 15.3824 35.7785C15.4992 35.7807 15.6146 35.7527 15.7173 35.697Z'
            fill='url(#paint7_linear_3859_1202)'
        />
        <path
            opacity='0.3'
            d='M11.3545 34.7409C11.2557 34.7404 11.1588 34.714 11.0733 34.6644L1.17568 28.9058C0.818924 28.6972 0.522888 28.399 0.316918 28.0407C0.110948 27.6824 0.00220535 27.2766 0.0014656 26.8633V12.5117C0.00121937 12.289 0.0613214 12.0703 0.175393 11.879C0.289464 11.6877 0.453271 11.5309 0.649341 11.4252L6.23023 8.39517C6.35012 8.32933 6.48514 8.29594 6.62191 8.29834C6.75867 8.30073 6.89245 8.33883 7.00996 8.40883C7.12747 8.47884 7.22469 8.57834 7.29191 8.69747C7.35914 8.8166 7.39406 8.95122 7.39324 9.08801V22.857C7.39391 23.2307 7.49224 23.5977 7.67848 23.9216C7.86473 24.2456 8.1324 24.5152 8.45498 24.7038L11.296 26.3594C11.4828 26.4683 11.6378 26.6243 11.7456 26.8118C11.8533 26.9992 11.9101 27.2117 11.9101 27.4279V34.1763C11.9107 34.3247 11.8527 34.4673 11.7486 34.573C11.6445 34.6788 11.5029 34.7391 11.3545 34.7409Z'
            fill='url(#paint8_linear_3859_1202)'
        />
        <path
            d='M11.8048 27.4278V34.1762C11.8047 34.2552 11.7839 34.3327 11.7444 34.401C11.7049 34.4694 11.6481 34.5261 11.5797 34.5655C11.5113 34.6049 11.4337 34.6257 11.3548 34.6257C11.2759 34.6257 11.1983 34.6049 11.13 34.5654L7.28792 32.3272L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28832 23.2514 7.39245 23.6388 7.58986 23.9803C7.78727 24.3219 8.07103 24.6055 8.41265 24.8027L11.2537 26.4561C11.4223 26.556 11.5618 26.6982 11.6585 26.8687C11.7551 27.0391 11.8056 27.2319 11.8048 27.4278Z'
            fill='url(#paint9_linear_3859_1202)'
        />
        <path
            d='M11.13 34.5587L7.28792 32.3204L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28792 22.8569 6.84249 27.4008 11.13 34.5587Z'
            fill='url(#paint10_radial_3859_1202)'
        />
        <path
            opacity='0.3'
            d='M15.3952 35.8923C15.1864 35.8923 14.9862 35.8094 14.8385 35.6617C14.6909 35.5141 14.6079 35.3138 14.6079 35.105V4.7012C14.6085 4.4892 14.6631 4.28084 14.7666 4.09584C14.8701 3.91084 15.0192 3.75531 15.1995 3.64395L20.8007 0.222506C20.9245 0.148484 21.0659 0.108882 21.2101 0.107788C21.4191 0.107787 21.6196 0.190662 21.7677 0.338247C21.9157 0.485833 21.9991 0.686086 21.9997 0.895101V31.6791C21.9994 31.902 21.939 32.1207 21.825 32.3123C21.711 32.5038 21.5476 32.6612 21.3518 32.7678L15.7709 35.7956C15.6561 35.8595 15.5267 35.8928 15.3952 35.8923Z'
            fill='url(#paint11_linear_3859_1202)'
        />
        <path
            d='M15.7173 35.697L21.2981 32.6692C21.4765 32.5727 21.6254 32.4297 21.7292 32.2555C21.8329 32.0813 21.8876 31.8822 21.8875 31.6795V0.895504C21.8877 0.775422 21.8558 0.657474 21.7951 0.553835C21.7344 0.450196 21.6472 0.364619 21.5425 0.305932C21.4377 0.247246 21.3192 0.217575 21.1991 0.219985C21.0791 0.222394 20.9618 0.256798 20.8595 0.319641L15.2584 3.74108C15.0939 3.8417 14.9581 3.98287 14.864 4.15107C14.7698 4.31927 14.7205 4.50884 14.7207 4.7016V35.1054C14.721 35.2222 14.7516 35.3369 14.8095 35.4383C14.8674 35.5398 14.9506 35.6244 15.051 35.684C15.1515 35.7437 15.2656 35.7762 15.3824 35.7785C15.4992 35.7807 15.6146 35.7527 15.7173 35.697Z'
            fill='url(#paint12_linear_3859_1202)'
        />
        <path
            d='M11.8048 27.4278V34.1762C11.8047 34.2552 11.7839 34.3327 11.7444 34.401C11.7049 34.4694 11.6481 34.5261 11.5797 34.5655C11.5113 34.6049 11.4337 34.6257 11.3548 34.6257C11.2759 34.6257 11.1983 34.6049 11.13 34.5654L7.28792 32.3272L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28832 23.2514 7.39245 23.6388 7.58986 23.9803C7.78727 24.3219 8.07103 24.6055 8.41265 24.8027L11.2537 26.4561C11.4223 26.556 11.5618 26.6982 11.6585 26.8687C11.7551 27.0391 11.8056 27.2319 11.8048 27.4278Z'
            fill='url(#paint13_linear_3859_1202)'
        />
        <path
            opacity='0.3'
            d='M7.40078 22.857C7.40078 22.9132 7.01162 27.4639 11.2249 34.5002C11.238 34.5217 11.2434 34.5471 11.2401 34.572C11.2368 34.597 11.2251 34.6201 11.2069 34.6375C11.186 34.6584 11.1577 34.6705 11.1281 34.6712C11.1084 34.6705 11.0891 34.6651 11.0719 34.6554L1.17422 28.8968C0.817459 28.6882 0.521423 28.39 0.315453 28.0317C0.109484 27.6735 0.000740507 27.2676 7.53506e-07 26.8543V12.5117C-0.00024547 12.289 0.0598566 12.0703 0.173928 11.879C0.288 11.6877 0.451806 11.5309 0.647876 11.4252L6.22876 8.39517C6.34866 8.32933 6.48368 8.29594 6.62044 8.29834C6.75721 8.30073 6.89098 8.33883 7.0085 8.40883C7.12601 8.47884 7.22323 8.57834 7.29045 8.69747C7.35767 8.8166 7.3926 8.95122 7.39177 9.08801'
            fill='url(#paint14_linear_3859_1202)'
        />
        <path
            d='M11.13 34.5587L7.28792 32.3204L1.24583 28.7978C0.904533 28.6007 0.620978 28.3175 0.423586 27.9764C0.226193 27.6353 0.121892 27.2483 0.121094 26.8542V12.5116C0.121386 12.3092 0.176301 12.1106 0.280028 11.9368C0.383756 11.763 0.532478 11.6205 0.710481 11.5241L6.29137 8.49408C6.3942 8.43832 6.5098 8.41024 6.62675 8.41261C6.74371 8.41499 6.85803 8.44772 6.95852 8.50761C7.05901 8.5675 7.1422 8.65248 7.19994 8.75422C7.25768 8.85595 7.28803 8.97095 7.28792 9.08794V22.8569C7.28792 22.8569 6.84249 27.4008 11.13 34.5587Z'
            fill='url(#paint15_radial_3859_1202)'
        />
        <defs>
            <linearGradient
                id='paint0_linear_3859_1202'
                x1='18.4121'
                y1='41.2127'
                x2='18.2119'
                y2='-1.56766'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_3859_1202'
                x1='3.11513'
                y1='21.6602'
                x2='17.3835'
                y2='21.307'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint2_radial_3859_1202'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(5.62553 21.4847) scale(14.869 14.869)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='paint3_linear_3859_1202'
                x1='18.4121'
                y1='41.2127'
                x2='18.2119'
                y2='-1.56766'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint4_linear_3859_1202'
                x1='3.11513'
                y1='21.6602'
                x2='17.3835'
                y2='21.307'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint5_radial_3859_1202'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(5.62553 21.4847) scale(14.869 14.869)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='paint6_linear_3859_1202'
                x1='18.4118'
                y1='41.3585'
                x2='18.2116'
                y2='-1.69178'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint7_linear_3859_1202'
                x1='18.4121'
                y1='41.2127'
                x2='18.2119'
                y2='-1.56766'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint8_linear_3859_1202'
                x1='3.06074'
                y1='21.6625'
                x2='17.6058'
                y2='21.3026'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint9_linear_3859_1202'
                x1='3.11513'
                y1='21.6602'
                x2='17.3835'
                y2='21.307'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint10_radial_3859_1202'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(5.62553 21.4847) scale(14.869 14.869)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
            <linearGradient
                id='paint11_linear_3859_1202'
                x1='18.4118'
                y1='41.3585'
                x2='18.2116'
                y2='-1.69178'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint12_linear_3859_1202'
                x1='18.4121'
                y1='41.2127'
                x2='18.2119'
                y2='-1.56766'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint13_linear_3859_1202'
                x1='3.11513'
                y1='21.6602'
                x2='17.3835'
                y2='21.307'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#2139EB' />
                <stop offset='0.16' stopColor='#233DEB' />
                <stop offset='0.32' stopColor='#2848ED' />
                <stop offset='0.47' stopColor='#325BEF' />
                <stop offset='0.62' stopColor='#3F76F2' />
                <stop offset='0.77' stopColor='#5099F6' />
                <stop offset='0.91' stopColor='#64C3FB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <linearGradient
                id='paint14_linear_3859_1202'
                x1='5.69566'
                y1='37.0466'
                x2='5.34925'
                y2='5.53385'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </linearGradient>
            <radialGradient
                id='paint15_radial_3859_1202'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(9.04022 21.3948) scale(14.869 14.869)'
            >
                <stop stopColor='#1E65EB' />
                <stop offset='1' stopColor='#73E1FF' />
            </radialGradient>
        </defs>
    </svg>
);

export default NavbarLogoSmall;
